import gju from 'geojson-utils'
export default {
  /**
   * 获取某个区域内的随机点位
   * @param feature {geoJSon feature} 内部geometry为MultiPolygon类型，properties需要有centroid中心点位数据
   * @param extent {number} 随机程度，经纬度偏移程度
   * @author zhubincong
   * @since 2020-03-18 13:42:36
   */

  getRandomPointInMultiPolygon(feature, extent = 1e-1) {
    if (feature.type !== 'Feature') {
      throw new Error('需传入Feature！')
    }
    const centroid = feature.properties.centroid
    const point = {}
    let times = 0
    do {
      const offset = [Math.random() * extent, Math.random() * extent]
      point.coordinates = [
        Math.random() > 0.5 ? centroid[0] + offset[0] : centroid[0] - offset[0],
        Math.random() > 0.5 ? centroid[1] + offset[1] : centroid[1] - offset[1]
      ]
      times++
      // 最多尝试1k次
    } while (!gju.pointInPolygon(point, feature.geometry) && times < 1e4)
    return point.coordinates || centroid
  },
  /**
   * 为某个列表数据生成区域内随机经纬度
   * @param list 列表
   * @param geoJson 完整的geoJson数据，来源http://datav.aliyun.com/tools/atlas
   * @author zhubincong
   * @since 2020-03-18 14:25:17
   */
  getRandomPoint4List(list, geoJson) {
    list.forEach(n => {
      const feature = geoJson.features.find(m => +m.properties.adcode === +n.regionCode)
      if (feature) {
        const point = this.getRandomPointInMultiPolygon(feature)
        n.longitude = point[0]
        n.latitude = point[1]
      }
    })
    return list
  },

  /**
   * @author xuchen
   * @date 2020-05-25 13:37:58
   * @desc 外部点击指令
   */
  clickoutside: {
    bind(el, binding, vnode) {
      function documentHandler(e) {
        if (el.contains(e.target)) {
          return false
        }
        if (binding.expression) {
          binding.value(e)
        }
      }
      el.__vueClickOutside__ = documentHandler
      document.addEventListener('click', documentHandler)
    },
    update() {},
    unbind(el, binding) {
      document.removeEventListener('click', el.__vueClickOutside__)
      delete el.__vueClickOutside__
    }
  }
}
